import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderTransferRequestImplEncoder } from "../../encoder/OrderTransferRequestImplEncoder";

import * as CubiqTS from "../../index";
import { OrderTransferRequest } from "../OrderTransferRequest";

export class OrderTransferRequestImpl extends ConcreteEncodable implements OrderTransferRequest {
  public static enType: string = "com.bcdfx.model.event.OrderTransferRequestImpl";

  /*FID=1*/
  public xferAction: CubiqTS.XferAction;
  /*FID=2*/
  public orderIds: Array<string> | null = null;
  /*FID=3*/
  public targetGroupID: CubiqTS.Long | null = null;
  /*FID=4*/
  public comment: string;
  /*FID=5*/
  public benchmarkXfer: boolean;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderTransferRequestImplEncoder.Instance;
    this.setEncodableType(OrderTransferRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "OrderTransferRequestImpl[" +
      "xferAction=" +
      this.xferAction +
      "orderIds=" +
      this.orderIds +
      "targetGroupID=" +
      this.targetGroupID +
      "comment=" +
      this.comment +
      "benchmarkXfer=" +
      this.benchmarkXfer +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
